module.exports = __webpack_public_path__ + "img/美妆-2.92c56c67.png";